import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import React, { ChangeEvent, FC } from "react";

import CheckBox from "../../../../../components/elements/CheckBox";
import classes from "../../StateProvinceSelectionSlide.module.scss";
import { GeoTargetOption } from "../../../../../types/campaignTypes";

type RegionsProps = {
  regions: GeoTargetOption[];
  checkBoxes: Record<string, boolean>;
  label: string;
  country_code_3: "USA" | "CAN";
  handleSelectAll: (event: ChangeEvent<{}>) => void;
  handleChange: (event: ChangeEvent<{}>) => void;
};

const Regions: FC<RegionsProps> = ({ regions, checkBoxes, label, country_code_3, handleSelectAll, handleChange }) => {
  return (
    <div className={classes.regions}>
      <FormControl component="fieldset">
        <FormLabel component="legend" className={classes.fieldsetLegend}>
          {label}
        </FormLabel>

        <FormGroup className={classes.formGroup}>
          <CheckBox
            checked={!!checkBoxes[`${country_code_3}_ALL`]}
            onChange={handleSelectAll}
            name={`${country_code_3}_ALL`}
            label="Select all"
            className={classes.checkbox}
          />

          {regions.map((region) => (
            <CheckBox
              key={region.key}
              checked={checkBoxes[region.key]}
              onChange={handleChange}
              name={region.key}
              label={region.region_name}
            />
          ))}
        </FormGroup>
      </FormControl>
    </div>
  );
};

export default Regions;
